import React from 'react'

const score = () => {
  return (
    <div className='score'>
      <center><h3>SCORE</h3></center>
      
       <center><h1 id='finalScore'>0</h1></center>

    </div>
  )
}

export default score
